import { Component } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { FAQService } from 'src/app/Services/faq.service';
import { UserData } from 'src/app/Models/employee-and-user-data';

type FAQ = {
  faquid: Int16Array;
  faqQuestion: string;
  faqAnswer: string;
  expander: boolean;
};

@Component({
  selector: 'app-faq-expander',
  templateUrl: './faq-expander.component.html',
  styleUrls: ['./faq-expander.component.css'],
  providers: [FAQService],
})
export class FaqExpanderComponent {
  userdata?: UserData;
  shpid: number | undefined;
  OBPortalSvcURL = '';

  FAQs: FAQ[] | undefined;
  FAQdata: any;

  constructor(
    private appConfigService: AppConfigService,
    private FAQService: FAQService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.shpid = this.userdata?.shipid!;

    this.getShipFAQs();
  }

  getShipFAQs() {
    this.FAQdata = this.FAQService.getShipFAQs(this.shpid).subscribe(
      (FAQdata) => this.setShipFAQ(FAQdata)
    );
  }

  setShipFAQ(resdata: any) {
    this.FAQdata = resdata;
    if (this.FAQdata.GetShipFAQ.Result.Status == 'A') {
      this.FAQs = this.FAQdata.GetShipFAQ.ShipFAQList;
    }
  }
}
